import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Home, ArrowLeft } from 'lucide-react';
import { motion } from 'framer-motion';
import { Button } from '@/components/Button';

const NotFound: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center max-w-lg"
      >
        <div className="mb-8">
          <span className="text-9xl font-heading font-bold text-secondary">404</span>
        </div>
        <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-4">
          Pagina non trovata
        </h1>
        <p className="text-text-light font-body text-lg mb-8">
          La pagina che stai cercando non esiste o è stata spostata. 
          Torna alla home page per continuare la navigazione.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button href="/" variant="secondary" size="lg" icon={<Home size={20} />}>
            Torna alla Home
          </Button>
          <Button
            onClick={() => window.history.back()}
            variant="outline"
            size="lg"
            icon={<ArrowLeft size={20} />}
          >
            Torna Indietro
          </Button>
        </div>
      </motion.div>
    </div>
  );
};

export default NotFound;
